/* eslint-disable jsx-a11y/alt-text */
import React,{} from "react";
import { Link } from "react-router-dom";
import "./Web1920135.css";

function Web1920135(props) {
  
  const { warp, path14, path15, group583 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-135 screen">
        <div className="overlap-group-39">
          <img className="warp-10" src={warp} />
          <div className="rectangle-2-33 border-1px-dove-gray"></div>
          <img className="path-14-9" src={path14} />
          <img className="path-15-8" src={path15} />
          <Link to="/web-1920-10">
            <div className="group-583-25" style={{ backgroundImage: `url(${group583})` }}></div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920135;
